import React from 'react';

import { useUserStore } from 'v2/store/User';

import { Consultancy } from './components/Consultancy';
import ManagerInfo from './components/ManagerInfo';

interface IProps {
  hasPublicManager: boolean;
  hasConsultancy: boolean;
}

function AccountManager({ hasPublicManager, hasConsultancy }: IProps) {
  const { user } = useUserStore(({ user }) => ({ user }));

  const managerInfoComponent = () => (hasPublicManager ? <ManagerInfo data={user.account_manager} /> : null);

  return <>{hasConsultancy ? <Consultancy user={user} /> : managerInfoComponent()}</>;
}

export default AccountManager;
